import { REQUEST_LOCALE, RECEIVE_LOCALE } from '../constants';

import { default as config } from '../../utilities/config';
import mcUserInfo from '../../utilities/mcUserInfo';
import { getUserData } from '../../utilities/blockSdkHelper';
import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

const DEFAULT_TIMEOUT_MS = 5000;

export function getLocale(options = {}) {
  const promiseTimeout = function(ms, promise) {
    // Use the default (en-US) if this promise takes longer than the desired ms
    let timeout = new Promise((resolve, reject) => {
      let id = setTimeout(() => {
        clearTimeout(id);
        resolve({ locale: options.locale, timedOut: true });
      }, ms);
    });

    // Promise.race will take the result of whichever promise completes first
    return Promise.race([promise, timeout]);
  };

  return dispatch => {
    dispatch({ type: REQUEST_LOCALE, useBlockSdk: options.useBlockSdk });

    if (options.useBlockSdk) {
      // Use a race to eventually load the default when running locally
      return promiseTimeout(
        config.intlTimeoutMs || DEFAULT_TIMEOUT_MS,
        getUserData()
      ).then(({ locale }) =>
        dispatch({
          type: RECEIVE_LOCALE,
          useBlockSdk: options.useBlockSdk,
          locale
        })
      );
    }

    return mcUserInfo(options.mcLib).then(locale =>
      dispatch({
        type: RECEIVE_LOCALE,
        useBlockSdk: options.useBlockSdk,
        locale
      })
    );
  };
}

function requestSession() {
  return {
    type: Constants.REQUEST_SESSION
  };
}

function receiveSession(json, error) {
  return {
    type: Constants.RECEIVE_SESSION,
    data: json,
    error
  };
}

export function getSession(options = {}) {
  const path = 'ecs/session';
  return new Endpoint(path, requestSession, receiveSession)
    .withMethod('GET')
    .withOptions(options)
    .call();
}
